/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCornerDownRightDouble = createReactComponent("outline", "corner-down-right-double", "IconCornerDownRightDouble", [["path", { "d": "M4 5v6a3 3 0 0 0 3 3h7", "key": "svg-0" }], ["path", { "d": "M10 10l4 4l-4 4m5 -8l4 4l-4 4", "key": "svg-1" }]]);

export { IconCornerDownRightDouble as default };
//# sourceMappingURL=IconCornerDownRightDouble.mjs.map
